<template>
  <div class="manageColumns">
    <button
      :class="['toggle-button', { active: showDropdown }]"
      @click="showDropdown = !showDropdown"
    >
      <icon size="18" @click="showDropdown = !showDropdown">view_column</icon>
      Manage Columns
    </button>
    <SlideYUpTransition>
      <div
        v-if="showDropdown"
        class="manageColumnsDropdown smooth-shadow"
        v-click-outside="
          () => {
            showDropdown = false;
          }
        "
      >
        <simplebar
          class="list-wrapper"
          data-auto-hide="false"
          scrollbarMaxSize="30"
        >
          <div
            v-for="header in headers"
            :key="header.text"
            @click="selectItem($event, header)"
            class="option flex-row-align-center"
          >
            <icon
              class="mar-right-10"
              :checked="isSelected(header.text) ? 'checked' : ''"
              >{{
                isSelected(header.text)
                  ? "check_box"
                  : "check_box_outline_blank"
              }}</icon
            >
            <p class="ellipsis">{{ header.text }}</p>
          </div>
        </simplebar>
      </div>
    </SlideYUpTransition>
  </div>
</template>

<script>
import { SlideYUpTransition } from "vue2-transitions";

export default {
  components: {
    SlideYUpTransition,
  },
  props: {
    headers: Array,
    value: Array,
  },
  data() {
    return {
      showDropdown: false,
    };
  },
  methods: {
    selectItem($event, option) {
      // disable the click listener if it is inside the options list
      $event.stopPropagation();
      // remove if the item is already in the selected list
      let newValues = [...this.value];
      if (this.isSelected(option.text)) {
        newValues = newValues.filter((item) => {
          return item.text !== option.text;
        });
      } else {
        newValues.push(option);
      }
      this.$emit("input", newValues);
    },
    /**
     * function to check if the item is already selected
     */
    isSelected(text) {
      return !!this.value.find((option) => {
        return option.text === text;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.manageColumns {
  position: relative;

  .manageColumnsDropdown {
    position: absolute;
    top: 100%;
    left: 0;
    background: var(--color-secondary-light);
    width: 100%;
    margin-top: 5px;
    border-radius: 5px;
    z-index: 4;
    box-sizing: border-box;
    overflow: auto;
    max-height: 300px;

    .list-wrapper {
      overflow: auto;
      max-height: 250px;
    }

    .option {
      padding: 7px 10px;
      border-bottom: 1px solid var(--border-color);

      &:last-child {
        border: 0;
      }

      &:hover {
        background-color: var(--border-color);
        cursor: pointer;
      }

      i {
        pointer-events: none;
      }

      p {
        margin: 0;
      }
    }
  }
}
</style>
